import React, { lazy } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { AuthRoute } from 'routes/components';
import Page404 from 'components/error/page404';
import { urlMap } from 'routes/urlMap';

/*
- Suspense is upstream in the main routes switch
- react lazy doesnt support named exports (https://github.com/reactjs/rfcs/pull/64#issuecomment-431507924)
*/
const NewTemplateContainer = lazy(async () => (import(/* webpackChunkName: "NewTemplateContainer" */'components/pages/jobForm')).then(module => ({ default: module.NewTemplateContainer })));
const NewJobRequestContainer = lazy(async () => import(/* webpackChunkName: "NewJobRequestContainer" */'components/pages/jobForm').then(module => ({ default: module.NewJobRequestContainer })));
const EditJobRequestContainer = lazy(async () => import(/* webpackChunkName: "EditJobRequestContainer" */'components/pages/jobForm').then(module => ({ default: module.EditJobRequestContainer })));
const EditTemplateContainer = lazy(async () => import(/* webpackChunkName: "EditTemplateContainer" */'components/pages/jobForm').then(module => ({ default: module.EditTemplateContainer })));
const JobFormChooser = lazy(async () => import(/* webpackChunkName: "JobFormChooser" */'components/pages/jobRequestSelector'));
const JobFormFromSource = lazy(() => import(/* webpackChunkName: "JobFormFromSource" */'components/pages/jobRequestSelector/reposter'));

// we could do better here if we use the base path, which is passed in via props
// to construct sub-paths rather than building that logic into the urlMap
export const NewJobRequestRoutes = () => (
  <Switch>
    <Route exact path={urlMap.NEW_JOB}>
      <Redirect to={urlMap.CREATE_MODULAR_ORDER} />
    </Route>
    <AuthRoute exact path={urlMap.NEW_JOB_FROM_COPY} component={JobFormFromSource} />
    <AuthRoute exact path={urlMap.NEW_JOB_FROM_REPOST} component={JobFormFromSource} />
    <AuthRoute exact path={urlMap.NEW_JOB_FROM_SCRATCH} component={NewJobRequestContainer} />
    <AuthRoute exact path={urlMap.NEW_JOB_FROM_TEMPLATE} component={JobFormFromSource} />
    <Route component={Page404} />
  </Switch>
);

export const NewTemplateRoutes = () => (
  <Switch>
    <AuthRoute exact path={urlMap.NEW_TEMPLATE} component={NewTemplateContainer} />
    <Route component={Page404} />
  </Switch>
);

export const EditTemplateRoutes = () => (
  <Switch>
    <AuthRoute exact path={urlMap.EDIT_TEMPLATE} component={EditTemplateContainer} />
    <AuthRoute exact path={urlMap.EDIT_TEMPLATE_SECTION} component={EditTemplateContainer} />
    <Route component={Page404} />
  </Switch>
);

export const EditJobRequestRoutes = () => (
  <Switch>
    <AuthRoute exact path={urlMap.EDIT_JOB} component={EditJobRequestContainer} />
    <AuthRoute exact path={urlMap.EDIT_JOB_SECTION} component={EditJobRequestContainer} />
    <Route component={Page404} />
  </Switch>
);

// @todo: phase these out in favour of the new job request routes
export const LegacyJobRequestRoutes = () => (
  <Switch>
    <AuthRoute exact path={urlMap.NEW_JOB_LEGACY} component={JobFormChooser} />
    <AuthRoute exact path={urlMap.NEW_JOB_REPOST_LEGACY} component={JobFormFromSource} />
    <AuthRoute exact path={urlMap.NEW_JOB_FROM_SCRATCH_LEGACY} component={NewJobRequestContainer} />
    <AuthRoute exact path={urlMap.NEW_JOB_EDIT_LEGACY} component={EditJobRequestContainer} />
    <Route component={Page404} />
  </Switch>
);
